import * as ExcelJS from 'exceljs';

import { downloadUrl } from '@utils/download';
import { formatDate } from '@utils/date';
import type { ClaimResponse } from '../models';
import { CLAIM_STATUS_LABELS } from '../constants';

export async function exportClaimsToExcel(claims: ClaimResponse[]) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Claims');

  // Add headers
  worksheet.addRow(['Tegenpartij', 'Onderaannemer', 'Bedrag (€)', 'Status', 'Info', 'Aangemaakt op']);

  // Style the header row
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE0E0E0' },
  };

  // Add data rows
  claims.forEach((claim) => {
    worksheet.addRow([
      claim.counterParty,
      claim.supplierName || '-',
      (claim.amount / 100).toFixed(2),
      CLAIM_STATUS_LABELS[claim.status] || claim.status,
      claim.info || '-',
      formatDate(claim.createdAt),
    ]);
  });

  // Auto-fit columns
  worksheet.columns.forEach((column) => {
    let maxLength = 0;
    if (column.eachCell) {
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
    }
    column.width = Math.min(Math.max(maxLength + 2, 10), 50);
  });

  // Generate Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  // eslint-disable-next-line no-restricted-globals
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);

  const today = new Date().toLocaleDateString('nl-BE');
  const filename = `claims_${today}.xlsx`.replace(/\//g, '-');

  downloadUrl(url, { filename });

  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 10000);
}
